import styled from 'styled-components';

export const MirroredImageWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  top: -200px;
  margin-bottom: -200px;

  @media (min-width: 1600px) {
    top: -210px;
    margin-bottom: -210px;
  }

  @media (min-width: 1920px) {
    top: -230px;
    margin-bottom: -230px;
  }

  @media (min-width: 2560px) {
    top: -260px;
    margin-bottom: -260px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  will-change: transform;
`;

export const Img = styled.img`
  height: auto;
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  max-width: 500px;

  /* Desktop 960 */
  @media (min-width: 960px) {
    max-width: 500px;
  }

  /* Desktop 1600+ */
  @media (min-width: 1600px) {
    max-width: 520px;
  }

  /* Desktop 1920+ */
  @media (min-width: 1920px) {
    max-width: 550px;
  }

  /* Desktop 2560+ */
  @media (min-width: 2560px) {
    max-width: 650px;
  }
`;
